// Standalone login page for host admins. Posts to /api/system/auth/login,
// stores the resulting token under a different localStorage key
// ('identium_host_token') so a host session and a tenant session can both
// be open in the same browser without trampling each other.

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { MdAdminPanelSettings, MdLock, MdPerson, MdLogin } from 'react-icons/md';
import api from '../../api/axios';

export default function HostLogin() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      // Bypass the request interceptor's tenant token by passing a custom
      // header — we want to authenticate as host and need the response to
      // come back without a tenant Authorization being sent.
      const res = await api.post('/system/auth/login', { username, password },
        { headers: { Authorization: '' } });
      const { token, user } = res.data;
      localStorage.setItem('identium_host_token', token);
      localStorage.setItem('identium_host_user', JSON.stringify(user));
      navigate('/host/companies');
    } catch (err) {
      setError(err.response?.data?.error || 'Host login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #1a1a2e 0%, #2d3561 100%)',
      display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20,
    }}>
      <form onSubmit={submit} style={{
        background: 'white', borderRadius: 16, padding: 32, width: '100%', maxWidth: 420,
        boxShadow: '0 20px 60px rgba(0,0,0,0.4)',
      }}>
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <div style={{
            width: 64, height: 64, borderRadius: 14,
            background: 'linear-gradient(135deg, #6a1b9a, #c2185b)',
            display: 'inline-flex', alignItems: 'center', justifyContent: 'center', marginBottom: 14,
          }}>
            <MdAdminPanelSettings style={{ color: 'white', fontSize: 32 }} />
          </div>
          <h2 style={{ margin: 0, fontSize: 22, color: '#1a1a2e', fontWeight: 800, letterSpacing: '0.5px' }}>HOST CONSOLE</h2>
          <p style={{ margin: '4px 0 0', fontSize: 12, color: '#78909c' }}>For platform administrators only</p>
        </div>
        {error && <div className="alert alert-danger" style={{ marginBottom: 16, fontSize: 13 }}>{error}</div>}
        <Field icon={<MdPerson />} label="Username" type="text" value={username} onChange={setUsername} placeholder="host" />
        <Field icon={<MdLock />}   label="Password" type="password" value={password} onChange={setPassword} placeholder="••••••••" />
        <button type="submit" disabled={loading} style={{
          width: '100%', padding: 14, marginTop: 8,
          background: 'linear-gradient(135deg, #6a1b9a, #c2185b)',
          color: 'white', border: 'none', borderRadius: 10,
          fontSize: 15, fontWeight: 700, cursor: loading ? 'not-allowed' : 'pointer',
          display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
        }}>
          <MdLogin />
          {loading ? 'Signing in...' : 'Sign in to host console'}
        </button>
      </form>
    </div>
  );
}

function Field({ icon, label, value, onChange, ...rest }) {
  return (
    <div style={{ marginBottom: 14 }}>
      <label style={{
        display: 'block', fontSize: 11, fontWeight: 700,
        color: '#546e7a', textTransform: 'uppercase', letterSpacing: '0.8px', marginBottom: 6,
      }}>{label}</label>
      <div style={{ display: 'flex', alignItems: 'center', border: '1.5px solid #e0e6ef', borderRadius: 10, overflow: 'hidden' }}>
        <div style={{ padding: '0 14px', color: '#90a4ae', fontSize: 18, borderRight: '1.5px solid #e0e6ef',
                       display: 'flex', alignItems: 'center', background: '#f8fafc', height: 44 }}>{icon}</div>
        <input
          {...rest}
          value={value}
          onChange={e => onChange(e.target.value)}
          style={{ flex: 1, border: 'none', outline: 'none', padding: '11px 14px', fontSize: 14, background: 'white' }}
        />
      </div>
    </div>
  );
}
